<template>
    <div class="social-share-bottom">
        <sharePost :shareArr="[{title: options[0].title, data_title: options[0].data_title, data_link: options[0].data_link}]" class="bazis-club-share"></sharePost>
        <div class="btn-to-call-center btn-form btn-to-call-bazisclub btn-social-share-bottom">
            <a href="#" @click.prevent="getConsultation()">
                <span v-if="lang != 'kz/'">ЗАКАЗАТЬ КОНСУЛЬТАЦИЮ</span>
                <span v-else>Кеңес алуға тапсырыс беру</span>
            </a>
        </div>
    </div>
</template>

<script>
    import sharePost from '@/components/share/share-post.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'social-share-bottom',
        props: ['options'],
        components: {
            sharePost,
        },
        data () {
            return {
                projectHost: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            currentCity: 'loadCurCity',
        }),
        methods: {
            getConsultation() {
                var data = {
                    'city': this.currentCity.region,
                    'page': 'sales-land-page',
                    'page_key': 'sales-land-page',
                }
                this.$store.commit('getFormConsultData', data);
                this.$store.commit('Open_form_Consult', true);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // console.log(data);
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>